'use client';

import { useState } from 'react';
import dynamic from 'next/dynamic';
import { useStore } from '@/store/store';
import { useStreamingUm } from '@/hooks/use-streaming-um';

// The streaming UM pulls in @stream-io/video-react-sdk (WebRTC) and cannot be
// server-rendered, so the player is loaded client-side only.
const LiveStreamPlayer = dynamic(() => import('@fanduel/casino-streaming-um-web').then((m) => m.LiveStreamPlayer), {
    ssr: false
});

type LivestreamPlayerClientProps = {
    sessionId: string;
    placeholderUrl?: string;
};

export const LivestreamPlayerClient = ({ sessionId, placeholderUrl }: LivestreamPlayerClientProps) => {
    const isLoggedIn = useStore((state) => state.userContext.isLoggedIn);
    const { ready } = useStreamingUm(isLoggedIn);
    const [errored, setErrored] = useState(false);

    // Viewer must be logged in (viewing is gated)
    const showPlayer = ready && isLoggedIn && !errored;

    return (
        <div className="livestream-player-placeholder" data-call-id={sessionId}>
            {!showPlayer && placeholderUrl && <img src={placeholderUrl} alt="" aria-hidden="true" loading="eager" />}
            {showPlayer && (
                <div className="livestream-player-mount">
                    <LiveStreamPlayer sessionId={sessionId} onError={() => setErrored(true)} />
                </div>
            )}
        </div>
    );
};
